import React from "react";

export const Header = () => (
  <section className="hero is-primary">
    <div className="hero-body">
      <div className="container">
        <h1 className="title">
          Play Swaras
        </h1>
        <h2 className="subtitle">
          Play swarasthanas in a korvai
        </h2>
      </div>
    </div>
  </section>
);